// utils/messages.js
import { functions } from '../firebase-client';
import { httpsCallable } from 'firebase/functions';

// Create or return an existing DM thread between two users
export async function startDirectMessage(user1, user2, teamId = null) {
  try {
    const startThreadFn = httpsCallable(functions, 'startThread');
    const result = await startThreadFn({
      userId1: user1.uid,
      userId2: user2.id,
      teamId // optional if it's a team chat, null if it's support
    });
    return result.data; // { id, ...threadData }
  } catch (err) {
    throw err;
  }
}

export async function setDirectThreadState(threadId, action) {
  const setThreadStateFn = httpsCallable(functions, 'setDirectThreadState');
  const result = await setThreadStateFn({ threadId, action });
  return result.data;
}

export async function getDirectMessageGifRating(threadId) {
  const fn = httpsCallable(functions, 'getDirectMessageGifRating');
  const result = await fn({ threadId });
  return result.data;
}

export async function sendDirectMessage({ threadId, content = '', media = null, mediaAttachments = [] }) {
  const fn = httpsCallable(functions, 'sendDirectMessage');
  const uploadIds = Array.isArray(mediaAttachments)
    ? mediaAttachments
      .filter((entry) => entry?.provider === 'firebase_upload' && entry?.uploadId)
      .map((entry) => entry.uploadId)
    : [];
  const payload = {
    threadId,
    content,
    ...(uploadIds.length > 0 ? { mediaUploadIds: uploadIds } : {}),
    ...(media?.provider === 'giphy' ? {
      media: {
        provider: 'giphy',
        providerId: media.providerId || media.id,
      },
    } : {}),
    ...(uploadIds.length === 0 && media?.provider === 'firebase_upload' ? {
      mediaUploadId: media.uploadId,
      media: {
        provider: 'firebase_upload',
        uploadId: media.uploadId,
      },
    } : {}),
  };
  const result = await fn({
    ...payload,
  });
  return result.data;
}
